/** AIAssistantInfra AI Agents name. */
export enum AIAgentName {
  BRAINSTORM_IDEAS = 'brainstorm_ideas',
  EXTRACT_6WTAGS = 'extract_6WTags',
  FIX_SPELLING_AND_LANGUAGE = 'fix_spelling_and_language',
  MAKE_LONGER = 'make_longer',
  MAKE_SHORTER = 'make_shorter',
  OUTLINE = 'outline',
  PROS_AND_CONS = 'pros_and_cons',
  SIMPLIFY = 'simplify',
  SUMMARIZE = 'summarize',
  TRANSLATE = 'translate',
  WRITE_A_POST = 'write_a_post',
  WRITE_A_STORY = 'write_a_story',
  WRITE_AN_ESSAY = 'write_an_essay',
  // The following agents are available but not used in Swym for now:
  // CHANGE_TONE = 'change_tone',
  // EXPLAIN = 'explain',
  // IMPROVE_WRITING = 'improve_writing',
  // EDIT = 'edit'
}
